import React, { memo, useCallback } from 'react';
import {
	Control,
	FieldErrors,
	FieldValues,
	UseFormSetValue,
} from 'react-hook-form';

import { Label, ModalSelect, Select } from '@components/common';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IModalSelectOption } from '@components/common/ModalSelect/ModalSelect.types';

import { EParametersFormValues } from '../../enums';

import styles from '../ConsistencyCheckOptions.module.scss';

interface IConsistencyMavenirOptions {
	control: Control;
	configTypesOptions: Array<TSelectOption>;
	versionsOptions: Array<TSelectOption>;
	errors: FieldErrors;
	nodeIdsOptions: IModalSelectOption[];
	setValue: UseFormSetValue<FieldValues>;
	nodes: IModalSelectOption[];
	vendor: string;
	version: string;
}

const ConsistencyCheckMavenirOptions = ({
	control,
	versionsOptions,
	configTypesOptions,
	nodeIdsOptions,
	errors,
	setValue,
	nodes,
	vendor,
	version,
}: IConsistencyMavenirOptions) => {
	const isNodeIdsDisabled = !vendor || !nodeIdsOptions.length;
	const isVersionDisabled = !nodes?.length || !versionsOptions.length;
	const isConfigTypeDisabled = !version || !configTypesOptions.length;

	const onChangeSites = useCallback((values: Array<IModalSelectOption>) => {
		setValue(EParametersFormValues.nodes, values);
	}, [setValue]);

	return (
		<div className={styles.groupOptions}>
			<Label
				className={styles.header}
				label='5G RAN Config'
			/>
			<div>
				<Label
					className={styles.sitesLabel}
					label='Nodes'
					required
				/>
				<ModalSelect
					disabled={isNodeIdsDisabled}
					label='Select nodes'
					modalLabel='Select nodes'
					onChange={onChangeSites}
					options={nodeIdsOptions}
					searchPlaceholder='Search by node ID'
					values={nodes}
				/>
			</div>
			<Select
				control={control}
				disabled={isVersionDisabled}
				errorMessage={errors.version?.message}
				isError={!!errors?.version}
				label='Release version'
				name={EParametersFormValues.version}
				options={versionsOptions}
				placeholder='Select release version'
				required
			/>
			<Select
				control={control}
				disabled={isConfigTypeDisabled}
				errorMessage={errors.configType?.message}
				isError={!!errors?.configType}
				label='Config type'
				name={EParametersFormValues.configType}
				options={configTypesOptions}
				placeholder='Select config type'
				required
			/>
		</div>
	);
};

export default memo(ConsistencyCheckMavenirOptions);
